export const getUserId = (state) => {
    return state.user_id
}

export const getUserName = (state) => {
    return state.user_name
}

export const getCreatedByItems = state => {
    return [
        {
            value: 'user',
            text: state.user_name
        },
        {
            value: 'company',
            text: state.company_name
        }
    ]
}

export const getCompanyId = (state) => {
    return state.company_id
}

export const getCompanyName = (state) => {
    return state.company_name
}

export const getPrimaryColor = (state) => {
    return state.primary_color
}

export const isPowerUser = (state) => {
    return state.is_power_user
}

export const getUserPermissions = (state) => {
    return state.permissions
}

export const getUserTimezone = (state) => {
    return state.time_zone
}

export const getNotificationsPreferences = (state) => {
    return state.notifications_preferences
}

export const getCompanyTier = (state) => {
    return state.tier
}

export const getCompanyTierStatus = (state) => {
    return state.tierStatus
}

export const getTierLoadingStatus = (state) => {
    return state.tier_loading
}